var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHdi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 40,
    viewBox: "0 0 112 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5702 13.7852H13.0469V26.7524H27.5702V13.7852Z",
    fill: "#DD2D27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0800781 0.818359H13.3329V39.7202H0.0800781V0.818359ZM27.2315 0.818359H40.4843V39.7202H27.2315V0.818359ZM97.8273 0.818359H111.08V39.7202H97.8308L97.8273 0.818359ZM51.5882 1.16796H69.5623C80.169 1.16796 88.85 9.85462 88.85 20.4064C88.85 30.9652 80.169 39.6501 69.5623 39.6501H51.5882V1.16796ZM63.7533 10.4784H65.284C71.3198 10.4784 76.2563 15.0666 76.2563 20.6699C76.2563 26.2768 71.3198 30.8614 65.284 30.8614H63.7533V10.4784Z",
    fill: "#00A657"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHdi);
export default __webpack_public_path__ + "static/media/hdi.5b9eaa7166064cf5b74cb9b02f2b5c2b.svg";
export { ForwardRef as ReactComponent };